import styled from 'styled-components'

export const CatalogItemDetailsFooterStyled = styled.div`
  flex-shrink: 0;
  padding: ${(props) => props.theme.space.medium};
  border-top: 1px solid ${(props) => props.theme.colors.content.secondaryBorder};
  background: ${(props) => props.theme.colors.content.contentBackground};
`
